module.exports = __webpack_public_path__ + "static/residential-062a8ebbabe9a98b21042851a838611b.jpg";